import { fetchWithAuth } from '../apiutil';

export const glimpseAPI = {
  /**
   * Get clip snapshot to set up model parameters
   * @param {string} accessToken - Current access token
   * @param {number} modelCaseId - Model case ID
   * @param {number} modelClipId - Model clip ID
   * @returns {Promise<Object>} Response with clip snapshot data
   */
  getModelClip: async (accessToken, modelCaseId, modelClipId) => {
    console.log(`[glimpseAPI.getModelClip] Loading clip: ${modelClipId} from case: ${modelCaseId}`);
    return fetchWithAuth(`/api/cases/${modelCaseId}/clips/${modelClipId}`, { 
      method: 'GET' 
    }, accessToken);
  },

  /**
   * Queue a glimpse processing request
   * @param {string} accessToken - Current access token
   * @param {number} sourceCaseId - Source case ID
   * @param {number} sourceClipId - Source clip ID
   * @param {Object} glimpseRequest - Complete glimpse request parameters
   * @returns {Promise<Object>} Response indicating success/failure
   */
  queueRequest: async (accessToken, sourceCaseId, sourceClipId, glimpseRequest) => {
    console.log("[glimpseAPI.queueRequest] Queueing glimpse request", glimpseRequest);
    return fetchWithAuth(`/api/cases/${sourceCaseId}/clips/${sourceClipId}/glimpse`, {
      method: 'POST',
      body: JSON.stringify(glimpseRequest)
    }, accessToken);
  }
};
